// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".compiled.css?v=" + "cb225dffe8f207da3d6a" + "";
};